import type { AcpPlanEntryData } from '@crowdex/agent-contracts';
import { TaskItem } from '@crowdex/ui/ai/task';
import { Check, Circle, CircleDot } from 'lucide-react';

export function PlanEntry({ entry }: { entry: AcpPlanEntryData }) {
  const Icon =
    entry.status === 'completed' ? Check : entry.status === 'in_progress' ? CircleDot : Circle;
  return (
    <TaskItem className="type-ui flex items-start gap-2 leading-5">
      <Icon className="mt-[3px] size-3.5 shrink-0 text-muted-foreground" />
      <span className={entry.status === 'completed' ? 'text-muted-foreground' : ''}>
        {entry.content}
      </span>
    </TaskItem>
  );
}
